import { useMemo } from "react";
import { filterNodesWithoutRoute, parseTasksToTree } from "./parseTasksToTree";
import { STATIC_TASKS } from "./staticTasks";
import type { AppTask, TaskTreeNode } from "./types";

interface UseTaskTreeOptions {
    /** Скрывать задачи без маппинга на route */
    hideTasksWithoutRoute?: boolean;
    /** Источник задач (по умолчанию статический список) */
    tasks?: AppTask[];
}

interface UseTaskTreeResult {
    nodes: TaskTreeNode[];
}

/**
 * Строит дерево задач из плоского списка.
 * Пока источник — {@link STATIC_TASKS}; позже можно подставить данные API.
 */
export function useTaskTree(options: UseTaskTreeOptions = {}): UseTaskTreeResult {
    const { hideTasksWithoutRoute = true, tasks = STATIC_TASKS } = options;

    const nodes = useMemo(() => {
        const tree = parseTasksToTree(tasks);
        return filterNodesWithoutRoute(tree, hideTasksWithoutRoute);
    }, [tasks, hideTasksWithoutRoute]);

    return { nodes };
}
